import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function StageIcon(props) {
    return (
        <img src={require('../../assets/images/lucrum-crm-white@3x.png')}/>
    );
}

export default StageIcon;